import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Etablissement } from 'src/model/model.etablissement';

@Injectable({
  providedIn: 'root'
})
export class EtablissementService {

  basePath = environment.BasePath+"/survey";

  constructor(private httpClient: HttpClient) { }




  getAllEtablissements(

  ): Observable<any> {

    return this.httpClient.get(this.basePath + "/etablissement")

  }


  getEtablissementsById(id: number): Observable<any>{
    return this.httpClient.get(this.basePath + "/etablissement/"+id)

  }
  getEtablissements(idUser: number, page: number, size: number, filters: any = {}): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    if (filters.etabName) params = params.set('etabName', filters.etabName);
    if (filters.etabType) params = params.set('etabType', filters.etabType);
    if (filters.jasperAdresse) params = params.set('jasperAdresse', filters.jasperAdresse);
    if (filters.jasperGsm) params = params.set('jasperGsm', filters.jasperGsm);
    if (filters.jasperEmail) params = params.set('jasperEmail', filters.jasperEmail);

    return this.httpClient.get(`${this.basePath}/chercheEtablissement`, {
      headers: { 'idUser': idUser.toString() },
      params
    });
  }
  saveEtablissements(etablissement: Etablissement): Observable<any> {
    return this.httpClient.post(this.basePath + "/etablissement",etablissement)
  }

  editEtablissement(etablissement:Etablissement): Observable<any>{
    return this.httpClient.put(this.basePath + "/etablissement/"+etablissement.id,etablissement)

  }

  deleteEtablissement(id:number): Observable<any>{

    return this.httpClient.delete(this.basePath + "/etablissement/"+id)

  }

  uploadImage(file:FormData): Observable<any>{

    return this.httpClient.post(this.basePath + "/img",file)
    .pipe(map(resp=>resp));
  }

  getPdf(): Observable<any> {

    return this.httpClient.get(this.basePath + "//Exportpdf");
  }

  uploadLogo(id: number, file: FormData): Observable<string> {
    return this.httpClient.post(`${this.basePath}/etablissement/${id}/upload-logo`, file)
        .pipe(map((response: any) => response.logoUrl));
}

// Updated to expect JSON response
uploadEtablissementLogo(id: number, file: FormData): Observable<string> {
    return this.httpClient.post(`${this.basePath}/etablissement/${id}/logo`, file)
        .pipe(map((response: any) => response.logoUrl));
}

getEtablissementLogo(id: number): Observable<string> {
    return this.httpClient.get(`${this.basePath}/etablissement/${id}/logo`, { responseType: 'text' });
}
}
